import { useToaster } from '@/components/shared/ToasterProvider'

type MutationResult<Data> = {
  data?: Data
  error?: { status: number; data: unknown }
  isError: boolean
  isSuccess: boolean
  isLoading: boolean
  isFetching: boolean
  isUninitialized: boolean
  isIdle: boolean
}

export default function useToastMutation<Data, Args extends any[], TriggerArg>(
  useMutationHook: (...args: Args) => readonly [
    (arg: TriggerArg) => Promise<{ data: Data; error?: undefined } | { data?: undefined; error: unknown }>,
    MutationResult<Data>,
  ],
  ...args: Args
) {
  const showToaster = useToaster()
  const [rawTrigger, result] = useMutationHook(...args)

  const trigger = async (arg: TriggerArg) => {
    try {
      return await rawTrigger(arg)
    } catch (err) {
      console.error(err)
      const message = err instanceof Error ? err.message : String(err)
      showToaster({ message })
      throw err
    }
  }

  return [trigger, result] as const
}
